function callAllCallbacks(fns) {
  fns.forEach(fn => {
    fn();
  });
}

// TODO: Maybe make this based on an LRU?
class ModuleDomNodeStore {
  constructor() {
    this.store = new Map();
    this.subscribers = new Set();
  }
  delete(key) {
    this.store.delete(key);
    callAllCallbacks(this.subscribers);
  }
  set(key, node) {
    this.store.set(key, node);
    callAllCallbacks(this.subscribers);
  }
  clear() {
    this.store.clear();
    callAllCallbacks(this.subscribers);
  }
  get(key) {
    return this.store.get(key);
  }
  subscribe(fn) {
    this.subscribers.add(fn);
    return () => {
      this.subscribers.delete(fn);
    };
  }
}
export default new ModuleDomNodeStore();